import React from 'react'
import tinycolor from 'tinycolor2'

import { getCssVariable } from '@fourthwall/components'
import type { useFormik } from '@fourthwall/utils/dist/formik'

import { getEmojiIcon } from '../../../../utils'
import type { FormValues } from '../../hooks/useBadgeForm/types'
import { FormFields } from '../../hooks/useBadgeForm/types'
import { ColorInput } from '../ColorInput'
import { EmojiInput } from '../EmojiInput'
import { MainInputsLayout } from '../MainInputsLayout/MainInputsLayout'

type Props = {
  form: ReturnType<typeof useFormik<FormValues>>
  verified?: boolean
}

export const MainInputs = ({ form, verified }: Props) => {
  const colorPrimary = getCssVariable('--color-primary')
  const colorOnPrimary = getCssVariable('--color-on-primary')
  const colorOnBackground = getCssVariable('--color-on-background')

  return (
    <MainInputsLayout>
      {!verified && (
        <EmojiInput
          emoji={getEmojiIcon(form.values.emoji)}
          onChange={(emoji) => {
            if (emoji.type === 'ImageResource') {
              form.setFieldValue(FormFields.emoji, {
                type: 'ImageResource',
                url: emoji.url,
                imageResourceId: emoji.imageResourceId,
              })
            } else {
              form.setFieldValue(FormFields.emoji, {
                type: 'Emoji',
                emojiIcon: emoji.emojiIcon,
              })
            }
          }}
        />
      )}
      {!verified && (
        <ColorInput
          label="Border"
          color={form.values.borderColor}
          defaultColor={tinycolor(colorOnBackground).setAlpha(0.3).toRgbString()}
          onChange={(color) => form.setFieldValue(FormFields.borderColor, color)}
        />
      )}
      <ColorInput
        label="Background"
        color={form.values.backgroundColor}
        defaultColor={
          verified ? colorPrimary : tinycolor(colorOnBackground).setAlpha(0.1).toRgbString()
        }
        onChange={(color) => form.setFieldValue(FormFields.backgroundColor, color)}
      />
      <ColorInput
        label={verified ? 'Icon color' : 'Text'}
        color={form.values.textColor}
        defaultColor={verified ? colorOnPrimary : colorOnBackground}
        onChange={(color) => form.setFieldValue(FormFields.textColor, color)}
      />
    </MainInputsLayout>
  )
}
